import type { AxiosRequestConfig } from "axios";
import type { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import type {
  GetAdminOrgUsageSummaryResponse,
  ListAdminOrgUsageParams,
  ListAdminOrgUsageResponse,
  ListAdminOrgUserUsageParams,
  ListAdminOrgUserUsageResponse,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  ORG_USAGE: "/api/v2/admin/usage/organizations",
  ORG_USER_USAGE: "/api/v2/admin/usage/organizations/:organization_id/users",
  SUMMARY: "/api/v2/admin/usage/summary",
};

export class AdminUsageAPI {
  constructor(private client: CohesiveAPIClient) {}

  /**
   * Paginated list of paying-org usage with engagement metrics and credit bands.
   */
  async listOrgUsage(
    params: ListAdminOrgUsageParams = {},
    config?: AxiosRequestConfig,
  ): Promise<ListAdminOrgUsageResponse> {
    const response = await this.client.axios.get<ListAdminOrgUsageResponse>(
      ENDPOINTS.ORG_USAGE,
      { ...config, params },
    );
    return response.data;
  }

  /**
   * Paginated per-user usage for a single organization.
   */
  async listOrgUserUsage(
    organizationId: string,
    params: ListAdminOrgUserUsageParams = {},
    config?: AxiosRequestConfig,
  ): Promise<ListAdminOrgUserUsageResponse> {
    const url = route(ENDPOINTS.ORG_USER_USAGE, {
      organization_id: organizationId,
    });
    const response = await this.client.axios.get<ListAdminOrgUserUsageResponse>(
      url,
      { ...config, params },
    );
    return response.data;
  }

  /**
   * Aggregate credit totals across paying orgs.
   */
  async getOrgUsageSummary(
    config?: AxiosRequestConfig,
  ): Promise<GetAdminOrgUsageSummaryResponse> {
    const response =
      await this.client.axios.get<GetAdminOrgUsageSummaryResponse>(
        ENDPOINTS.SUMMARY,
        config,
      );
    return response.data;
  }
}
